import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./Components/Invoice/InvoiceStyle.css";
import Sidebar from "./Components/SideBar";
import { SidebarProvider } from "./SidebarContext";
import ActivityLog from "./Components/ActivityLog";
import EmployeePerformance from "./Components/EmployeePerformance";
import Salaries from "./Components/Salaries";
import Leads from "./Components/Leads";
import Dashboard from "./Components/Dashboard/Dashboard";
import ReceivedPayment from "./Components/ReceivedPayment";
import DuePayment from "./Components/DuePayment";
import Offerings from "./Components/Offering";
import Onboarding from "./Components/Onboarding";
import AllUsers from "./Components/AllUsers";
import UserRecords from "./Components/UserRecords";
import ClassAgeGroup from "./Components/ClassAgeGroup";
import ClassLevels from "./Components/ClassLevels";
import ClassSchedule from "./Components/ClassSchedule";
import TeamDepartment from "./Components/TeamDepartment";
import TeamDirectory from "./Components/TeamDirectory";
import TeamAttendance from "./Components/TeamAttendance";
import Plan from "./Components/Plan";
import Branch from "./Components/Branch";
import Updates from "./Components/Updates";
import Equipments from "./Components/Equipments";
import Renewals from "./Components/Renewals";
import Category from "./Components/Category";
import Pincode from "./Components/Pincode";
import Delivery from "./Components/Delivery";
import Coupon from "./Components/Coupon";
import Orders from "./Components/Orders";
import Location from "./Components/Location";
import AddTimeLog from "./Components/AddTimeLog";
import TimeLog from "./Components/TimeLog";
import SalaryDetail from "./Components/SalaryDetail";
import Gallery from "./Components/Gallery";
import Login from "./Components/Login";
import UserRecordSuper from "./Components/UserRecordSuper";
import { ToastContainer } from "react-toastify";
import Attributes from "./Components/Attribute";
import Terms from "./Components/Terms/Terms";
import SimpleProduct from "./Components/Equipments/SimpleProduct";
import SimpleProductEdit from "./Components/Equipments/SimpleProductEdit";
import AffiliateProduct from "./Components/Equipments/AffiliateProduct";
import GroupedProduct from "./Components/Equipments/GroupedProduct";
import VariableProduct from "./Components/Equipments/VariableProduct";
import VariableProductEdit from "./Components/Equipments/VariableProductEdit";
import AffiliateProductEdit from "./Components/Equipments/AffiliateProductEdit";
import GroupedProductEdit from "./Components/Equipments/GroupedProductEdit";
import Unit from "./Components/Units/Unit";
import OrderUpdatedVersion from "./Components/LeadsUpdatedVersion/OrderUpdatedVersion";
import { getDecryptedUserFromCookie } from "./Components/utils/getCookie";
import axios from "axios";
import {
  listenToForegroundMessages,
  requestFCMToken,
} from "./Components/utils/firebaseUtils";
import Customer from "./Components/CustomerDetails/Customer";
import ProtectedRoute from "./Components/ProtectedRoute";
import CustomerImport from "./Components/CustomerDetails/CustomerImport";
import Export from "./Components/Invoice/export";
import Invoice from "./Components/Invoice/Invoice";
import NewInvoice from "./Components/Invoice/NewInvoice";
import InvoiceImport from "./Components/Invoice/InvoiceImport";
import InvoicePdf from "./Components/Invoice/InvoicePdf";
import ExportCustomer from "./Components/CustomerDetails/exportcustomer";
import AddCustomer2 from "./Components/CustomerDetails/AddCustomer2";
import AddCustomer3 from "./Components/CustomerDetails/AddCustomer3";
import Expenses from "./Components/Expense/Expense";
import ScrollToTop from "./Components/ScrollToTop";
import CRMUpdatedVersion from "./Components/CRMUpdatedVersion/CRMUpdatedVersion";
import Slider from "./Components/Slider/Slider";
import NewArrivals from "./Components/NewArrivals/NewArrivals";
import Offer from "./Components/Offer/Offer";
import Setting from "./Components/Setting/Setting";
import Marquee from "./Components/Marquee/Marquee";
import ExportExpense from "./Components/Expense/exportExpense";
import ExpenseImport from "./Components/Expense/ExpenseImport";
import CustomerDetail from "./Components/CustomerDetails/CustomerDetail";
import InvoiceDetail from "./Components/Invoice/InvoiceDetail";
import ExpenseDetail from "./Components/Expense/ExpenseDetail";
import EquipmentsDetail from "./Components/EquipmentsDetail";
import SettingUpdated from "./Components/SettingUpdated/SettingUpdated";
import ResetPassword from "./Components/ResetPassword";
import CategoryMain from "./Components/Category/CategoryMain";
import Admission from "./Components/Admission/Admission";
import AdmissionDetail from "./Components/Admission/AdmissionDetail";
import ExportAdmission from "./Components/Admission/exportadmission";
import AddAdmission2 from "./Components/Admission/AddAdmission2";
import AddAdmission3 from "./Components/Admission/AddAdmission3";
import Receipt from "./Components/Receipt";
import OrderCharts from "./Components/OtherCarts/OrderCharts";
import HelpAndSupport from "./Components/HelpAndSupport";
import { jwtDecode } from "jwt-decode";
import { decryptToken } from "./Components/utils/getToken";



const App = () => {
  const location = useLocation();
  const hideSidebarRoutes = ["/login", "/register", "/reset"];
  const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname);
  const token = decryptToken("accessToken") || ""
  const url = process.env.REACT_APP_LINK;
  const userData = getDecryptedUserFromCookie();
  const userLoggedIn = userData && userData.main_id;

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${url}/register/single/${userData.main_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      // setProfile(response.data);
      localStorage.setItem(
        "2xgxgshdugyywerw12gh",
        JSON.stringify(response.data.users)
      );
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  const [fcmToken, setfcmToeken] = useState(null);

  useEffect(() => {
    const fetchFcmToken = async () => {
      try {
        const token = await requestFCMToken();
        console.log(token);
        setfcmToeken(token);
      } catch (error) {
        console.error("error getting token ", error);
      }
    };
    fetchFcmToken();
    listenToForegroundMessages();
  }, []);

  useEffect(() => {
    if (fcmToken && userLoggedIn) {
      const saveToken = async () => {
        try {
          await axios.post(`${url}/firebase/register-token`, {
            user_id: userData.main_id,
            deviceToken: fcmToken,
          });
          console.log("FCM token saved");
        } catch (error) {
          console.error("Failed to save FCM token:", error);
        }
      };
      saveToken();
    }
  }, [fcmToken, userLoggedIn]);

  function logout() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("2xgxgshdugyywerw12eccom");
    localStorage.removeItem("2xgxgshdugyywerw12gh");
    window.location.href = "/login";
  }

  function checkTokenOnLoad() {
    const token = decryptToken("accessToken") || ""
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) {
        logout(); // token expired
      } else {
        const timeUntilExpiry = decoded.exp * 1000 - Date.now();
        setTimeout(() => {
          logout();
        }, timeUntilExpiry);
      }
    } catch (err) {
      logout();
    }
  }

  useEffect(() => {
    checkTokenOnLoad();
    fetchData();
  }, []);

  return (
    <SidebarProvider>
      <ScrollToTop />
      <div className="app-container">
        {/* Sidebar is always rendered */}
        {!shouldHideSidebar && <Sidebar />}
        {/* Main content area */}
        <div
          className={`main-content ${shouldHideSidebar ? "full-width" : ""}`}
        >
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer"
              element={
                <ProtectedRoute>
                  <Customer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admission"
              element={
                <ProtectedRoute>
                  <Admission />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer-detail/:id"
              element={
                <ProtectedRoute>
                  <CustomerDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admission-detail/:id"
              element={
                <ProtectedRoute>
                  <AdmissionDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice-detail/:id"
              element={
                <ProtectedRoute>
                  <InvoiceDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expense-detail/:id"
              element={
                <ProtectedRoute>
                  <ExpenseDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/product-detail/:id"
              element={
                <ProtectedRoute>
                  <EquipmentsDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer-import"
              element={
                <ProtectedRoute>
                  <CustomerImport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/export"
              element={
                <ProtectedRoute>
                  <Export />
                </ProtectedRoute>
              }
            />
            <Route
              path="/export-expense"
              element={
                <ProtectedRoute>
                  <ExportExpense />
                </ProtectedRoute>
              }
            />
            <Route
              path="/import-expense"
              element={
                <ProtectedRoute>
                  <ExpenseImport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice"
              element={
                <ProtectedRoute>
                  <Invoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/new-invoice"
              element={
                <ProtectedRoute>
                  <NewInvoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice-import"
              element={
                <ProtectedRoute>
                  <InvoiceImport />{" "}
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice-pdf/:order_number"
              element={
                <ProtectedRoute>
                  {" "}
                  <InvoicePdf />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-invoice/:id"
              element={
                <ProtectedRoute>
                  <NewInvoice isEditMode={true} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/export-customer"
              element={
                <ProtectedRoute>
                  <ExportCustomer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/export-admission"
              element={
                <ProtectedRoute>
                  <ExportAdmission />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-customer"
              element={
                <ProtectedRoute>
                  <AddCustomer2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-customer"
              element={
                <ProtectedRoute>
                  <AddCustomer2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-admission"
              element={
                <ProtectedRoute>
                  <AddAdmission3 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-admission"
              element={
                <ProtectedRoute>
                  <AddAdmission2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expense"
              element={
                <ProtectedRoute>
                  <Expenses />
                </ProtectedRoute>
              }
            />
            <Route path="/activity-log" element={<ActivityLog />} />
            <Route path="/time-log" element={<TimeLog />} />
            <Route path="/performance" element={<EmployeePerformance />} />
            <Route path="/salary" element={<Salaries />} />
            <Route
              path="/crm"
              element={
                <ProtectedRoute>
                  <CRMUpdatedVersion />
                </ProtectedRoute>
              }
            />
            <Route path="/received-payment" element={<ReceivedPayment />} />
            <Route path="/due-payment" element={<DuePayment />} />
            <Route path="/offerings" element={<Offerings />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route
              path="/all-users"
              element={
                <ProtectedRoute>
                  <AllUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-records"
              element={
                <ProtectedRoute>
                  <UserRecords />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alluser-records"
              element={
                <ProtectedRoute>
                  <UserRecordSuper />
                </ProtectedRoute>
              }
            />
            <Route path="/age-group" element={<ClassAgeGroup />} />
            <Route path="/class-level" element={<ClassLevels />} />
            <Route path="/class-schedule" element={<ClassSchedule />} />
            <Route path="/team-department" element={<TeamDepartment />} />
            <Route path="/team-directory" element={<TeamDirectory />} />
            <Route path="/team-attendance" element={<TeamAttendance />} />
            <Route path="/plan" element={<Plan />} />
            <Route path="/branch" element={<Branch />} />
            <Route path="/updates" element={<Updates />} />
            <Route
              path="/products"
              element={
                <ProtectedRoute>
                  <Equipments />
                </ProtectedRoute>
              }
            />
            <Route path="/renewals" element={<Renewals />} />
            <Route
              path="/category"
              element={
                <ProtectedRoute>
                  <Category />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pincode"
              element={
                <ProtectedRoute>
                  <Pincode />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delivery"
              element={
                <ProtectedRoute>
                  <Delivery />
                </ProtectedRoute>
              }
            />
            <Route
              path="/coupon"
              element={
                <ProtectedRoute>
                  <Coupon />
                </ProtectedRoute>
              }
            />
            <Route
              path="/slider"
              element={
                <ProtectedRoute>
                  <Slider />
                </ProtectedRoute>
              }
            />
            <Route
              path="/newarrival"
              element={
                <ProtectedRoute>
                  <NewArrivals />
                </ProtectedRoute>
              }
            />
            <Route
              path="/offer"
              element={
                <ProtectedRoute>
                  <Offer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/setting"
              element={
                <ProtectedRoute>
                  <SettingUpdated />
                </ProtectedRoute>
              }
            />
            <Route
              path="/setting1"
              element={
                <ProtectedRoute>
                  <SettingUpdated />
                </ProtectedRoute>
              }
            />
            <Route
              path="/marquee"
              element={
                <ProtectedRoute>
                  <Marquee />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reciept"
              element={
                <ProtectedRoute>
                  <Receipt />
                </ProtectedRoute>
              }
            />
            {/* <Route path="/orders" element={<Orders />} /> */}
            <Route path="/login" element={<Login />} />
            <Route path="/reset" element={<ResetPassword />} />
            {/* <Route path="/register" element={<Register />} /> */}

            <Route path="/location" element={<Location />} />
            <Route path="/salary-detail" element={<SalaryDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route
              path="/features"
              element={
                <ProtectedRoute>
                  <Attributes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/terms/:id"
              element={
                <ProtectedRoute>
                  <Terms />
                </ProtectedRoute>
              }
            />
            <Route
              path="/simple-product"
              element={
                <ProtectedRoute>
                  <SimpleProduct />
                </ProtectedRoute>
              }
            />
            <Route
              path="/external-affiliate-product"
              element={
                <ProtectedRoute>
                  <AffiliateProduct />
                </ProtectedRoute>
              }
            />
            <Route
              path="/grouped-product"
              element={
                <ProtectedRoute>
                  <GroupedProduct />
                </ProtectedRoute>
              }
            />
            <Route
              path="/variable-product"
              element={
                <ProtectedRoute>
                  <VariableProduct />
                </ProtectedRoute>
              }
            />
            <Route
              path="/variableedit-product/:id"
              element={
                <ProtectedRoute>
                  <VariableProductEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/simple-productedit/:id"
              element={
                <ProtectedRoute>
                  <SimpleProductEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/affiliate-productedit/:id"
              element={
                <ProtectedRoute>
                  <AffiliateProductEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/grouped-productedit/:id"
              element={
                <ProtectedRoute>
                  <GroupedProductEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/unit"
              element={
                <ProtectedRoute>
                  <Unit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <ProtectedRoute>
                  <OrderUpdatedVersion />
                </ProtectedRoute>
              }
            />
            <Route
              path="/category-main"
              element={
                <ProtectedRoute>
                  <CategoryMain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order-charts"
              element={
                <ProtectedRoute>
                  <OrderCharts />
                </ProtectedRoute>
              }
            />
            <Route path="/help-support" element={<HelpAndSupport />} />
          </Routes>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{ zIndex: 999999 }}
      />
    </SidebarProvider>
  );
};

export default App;
